import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Activity, Zap, Droplets, Brush, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  const services = [{
    icon: <Sparkles className="w-8 h-8" data-id="element-364" />,
    title: t('services', 's1Title'),
    desc: t('services', 's1Desc')
  }, {
    icon: <Activity className="w-8 h-8" data-id="element-365" />,
    title: t('services', 's2Title'),
    desc: t('services', 's2Desc')
  }, {
    icon: <Zap className="w-8 h-8" data-id="element-366" />,
    title: t('services', 's3Title'),
    desc: t('services', 's3Desc')
  }, {
    icon: <Droplets className="w-8 h-8" data-id="element-367" />,
    title: t('services', 's4Title'),
    desc: t('services', 's4Desc')
  }, {
    icon: <Brush className="w-8 h-8" data-id="element-368" />,
    title: t('services', 's5Title'),
    desc: t('services', 's5Desc')
  }, {
    icon: <Heart className="w-8 h-8" data-id="element-369" />,
    title: t('services', 's6Title'),
    desc: t('services', 's6Desc')
  }];
  return <section id="servicios" className="pt-10 pb-12 bg-beige-light" data-id="element-370">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-371">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-372">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-dark mb-6" data-id="element-373">
            {t('services', 'title')}
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-374"></div>
        </motion.div>

        {/* Services Collage Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7
      }} className="relative max-w-3xl mx-auto mb-12 group" data-id="element-375">
          <div className="absolute -inset-2 border border-gold/20 rounded-lg" data-id="element-376"></div>
          <div className="relative overflow-hidden rounded-md shadow-xl" data-id="element-377">
            <img src="https://cdn.magicpatterns.com/uploads/7TuuPSsDzSjqTfiuTmRtqW/servicios_lorena.png" alt="Lorena Beauty House — Servicios" className="w-full h-auto object-contain" data-id="element-378" />
            <div className="absolute inset-0 bg-gradient-to-tr from-gold/0 via-gold/5 to-gold/0 opacity-0 group-hover:opacity-100 transition-opacity duration-700" data-id="element-379"></div>
          </div>
          <div className="absolute -top-2 -left-2 w-8 h-8 border-t-2 border-l-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-tl-lg" data-id="element-380"></div>
          <div className="absolute -top-2 -right-2 w-8 h-8 border-t-2 border-r-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-tr-lg" data-id="element-381"></div>
          <div className="absolute -bottom-2 -left-2 w-8 h-8 border-b-2 border-l-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-bl-lg" data-id="element-382"></div>
          <div className="absolute -bottom-2 -right-2 w-8 h-8 border-b-2 border-r-2 border-gold/0 group-hover:border-gold transition-all duration-500 rounded-br-lg" data-id="element-383"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-384">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-sm border border-gold/20 shadow-sm hover:shadow-md hover:border-gold transition-all group" data-id="element-385">
              <div className="text-gold mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-386">
                {service.icon}
              </div>
              <h3 className="text-xl font-serif font-bold text-dark mb-3" data-id="element-387">
                {service.title}
              </h3>
              <p className="text-dark/70" data-id="element-388">{service.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.7
      }} className="mt-10" data-id="element-389">
          <h3 className="text-2xl md:text-3xl font-serif font-bold text-dark text-center mb-6" data-id="element-390">
            {t('services', 'priceTitle')}
          </h3>
          <div className="max-w-3xl mx-auto border-2 border-gold/30 rounded-sm shadow-lg overflow-hidden bg-white p-2" data-id="element-391">
            <img src="https://cdn.magicpatterns.com/uploads/21jbKt49my2c5FZvTiDomJ/precios_nuevos_lorena.png" alt={t('services', 'priceAlt')} className="w-full h-auto object-contain" data-id="element-392" />
          </div>
        </motion.div>
      </div>
    </section>;
}